import React from 'react';

import { TypographyListItem } from '@gogame/components';

export const ApproverListItem = ({ name, ...props }) => {
  return <TypographyListItem {...props}>{name}</TypographyListItem>;
};
